import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
    Table, TableBody, TableContainer, TableRow, TableHead, Paper, TableCell,
    CircularProgress, Alert, Accordion, AccordionSummary, AccordionDetails, Typography,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getRofBurnsBatchData } from '../../../../../../actions/rof-burns/rof-actions';

export default function RofBatchData({ projectKey, measureType }) {
    const dispatch = useDispatch();
    const [hideState, setHideState] = useState({});
    const [loading, setLoading] = useState(true);
    const rofBatchData = useSelector((state) => (state.rofBurnsReducer.batchData))

    const toggleHide = (batchId) => {
        setHideState(prev => ({
            ...prev,
            [batchId]: !prev[batchId]
        }));
    };

    useEffect(() => {
        if (projectKey) {
            dispatch(getRofBurnsBatchData(projectKey));
        }
        setLoading(false);
    }, [dispatch, projectKey]);

    if (loading) return <CircularProgress />

    if (!rofBatchData?.data?.length) {
        return <Alert severity="info">No Ring of Fire data for this project</Alert>;
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h5'>Ring of Fire Batch Data</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {rofBatchData.data.map((batch, index) => (
                    <Accordion key={index}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            onClick={() => toggleHide(`ROF - ${batch.batchId}`)}
                        >
                            <Typography>
                                {hideState[`ROF - ${batch.batchId}`] ? "Hide" : "Expand"} {batch.batchId}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <h3>Batch: {batch.batchId}</h3>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Kiln ID</TableCell>
                                            <TableCell>Gross Volume {measureType === 'Imperial' ? ' yrd³' : ' m³'}</TableCell>
                                            <TableCell>Partially Burnt Volume {measureType === 'Imperial' ? ' yrd³' : ' m³'}</TableCell>
                                            <TableCell>Net Volume {measureType === 'Imperial' ? ' yrd³' : ' m³'}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {batch.batchData.map((bd, idx) => (
                                            <TableRow key={idx}>
                                                <TableCell>{bd.kilnUsed}</TableCell>
                                                <TableCell>
                                                    {bd.grossVol
                                                        ? `${bd.grossVol}${measureType === 'Imperial'
                                                            ? ' yrd³' : ' m³'}`
                                                        : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {bd.partiallyBurntVol
                                                        ? `${bd.partiallyBurntVol}${measureType === 'Imperial'
                                                            ? ' yrd³' : ' m³'}`
                                                        : "0"}
                                                </TableCell>
                                                <TableCell>
                                                    {bd.netVol
                                                        ? `${bd.netVol}${measureType === 'Imperial'
                                                            ? ' yrd³' : ' m³'}`
                                                        : ""}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {batch?.additionalBatchData?.length > 0 &&
                                <>
                                    <h4 style={{ marginTop: '2em' }}>Additional Batch Data:</h4>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Kiln ID</TableCell>
                                                    <TableCell>Batch Location</TableCell>
                                                    <TableCell>Feedstock Type</TableCell>
                                                    <TableCell>Moisture Avg</TableCell>
                                                    <TableCell>Empty Bucket Mass</TableCell>
                                                    <TableCell>Bucket Volume</TableCell>
                                                    <TableCell>Hot Char & Bucket Weight</TableCell>
                                                    <TableCell>Kiln Depth</TableCell>
                                                    <TableCell>Height of Unburnt Pieces</TableCell>
                                                    <TableCell>Greater than or less than Panel Area</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {batch.additionalBatchData.map((batchData, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{batchData.kilnUsed}</TableCell>
                                                        <TableCell>
                                                            {batchData?.latitude && batchData?.longitude
                                                                ? `${batchData.latitude}, ${batchData.longitude}`
                                                                : ""}
                                                        </TableCell>
                                                        <TableCell>{batchData?.feedstockType || ""}</TableCell>
                                                        <TableCell>{batchData?.feedstockMoisture || ""}</TableCell>
                                                        <TableCell>{batchData?.emptyBucketMass || ""}</TableCell>
                                                        <TableCell>{batchData?.bucketVolume || ""}</TableCell>
                                                        <TableCell>{batchData?.hotCharAndBucketMass || ""}</TableCell>
                                                        <TableCell>{batchData?.kilnDepth || ""}</TableCell>
                                                        <TableCell>{batchData?.heightOfUnburntPieces || ""}</TableCell>
                                                        <TableCell>{batchData?.unburntPiecePanelArea || ""}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </>
                            }
                        </AccordionDetails>
                    </Accordion>
                )
                )}
            </Box>
        </Box>
    );
}